import { flatten, keyBy } from 'lodash';
import { ParamsFormOptions } from '../ads/model/params-form-option';
import { RECEIVE_TIME } from '../common/const';
import { FileTable } from '../files/model/file-table';
import { ServiceSettingsRoles, UserRole } from '../management/model/role';
import { MarkerType, Type } from '../map/model/marker-type';
import { BusStopReportNameOptions } from '../reports/model/bus-stop-report-name-options';
import { UserActivityEventType } from '../reports/model/user-activity-event-type';
import { DepartureFields } from '../sakp/model/departure';
import { SnvrParts, getAllSnvrParts } from '../snvr/util/snvr-parts';
import { DeviceSettingsType } from '../vehicles/model/device-settings-type';
import {
  DeviceType,
  getDeviceTypesForErrorLogReport,
  getPhysicalDeviceTypes
} from '../vehicles/model/device-type';
import { DirectionRouteSourceType } from '../vehicles/model/direction-route-source-type';
import { GpsFrameShowErrorStrategy } from '../vehicles/model/gps-frame';
import { RouteIdentifierType } from '../vehicles/model/route-identifier-type';
import { SettingGroup, SettingType } from './model/setting';

export const CHARTS_PASSENGERS_FLOW = 'charts_passengers_flow';

export const SETTING_VALUE_DISABLED = 'DISABLED';

// Dwa pierwsze to barwa kropki, trzeci - sylwetka pojazdu rysowana inaczej (maska w pseudoelemencie,
// patrz .custom-vehicle-image-marker), więc warstwa mapy rozpoznaje ją po nazwie, nie po pozycji.
export const VEHICLE_MARKER_BUS = 'markerBus';
export const VEHICLE_MARKER_OPTIONS = ['markerGreen', 'markerBlue', VEHICLE_MARKER_BUS];
export const VEHICLE_STATUS_MARKER_OPTIONS = ['markerStatusGreen', 'markerStatusBlue'];
export const AVAILABLE_CHART_TYPES = [CHARTS_PASSENGERS_FLOW];
export const VEHICLE_POPUP_FIELDS = [
  'sideNumber',
  'line',
  'directionName',
  'team',
  'course',
  'timetableDeviation',
  'previousBusStop',
  'nextBusStop',
  RECEIVE_TIME,
  'busFill',
  'errorCabinSwitches'
];
export const BUS_STOP_MARKER_OPTIONS = [
  'blackTriangle',
  'grayMarker',
  'stopImageBlack',
  'stopImageBlue',
  'stopImagePurple'
];
export const BUS_STOP_POPUP_FIELDS = ['name', 'description', 'code', 'carrierName'];

export const SETTING_DEVICES_BUTTON = 'devices_button';
export const SETTING_OPEN_VEHICLE_DEVICES = 'open_vehicle_devices';
export const SETTING_VEHICLE_MARKER = 'vehicle_marker';
export const SETTING_MAP_INITIAL_LATITUDE = 'map_initial_latitude';
export const SETTING_MAP_INITIAL_LONGITUDE = 'map_initial_longitude';
export const SETTING_MAP_INITIAL_ZOOM = 'map_initial_zoom';
export const SETTING_VEHICLE_STATUS_MARKER = 'vehicle_status_marker';
export const SETTING_BUS_STOPS_MENUITEM = 'busstops_menuitem';
export const SETTING_BUS_STOPS_STATISTICS_MENUITEM = 'busstops_statistics_menuitem';
export const SETTING_BUS_STOPS_STATISTICS_MIN_ROLE = 'busstops_statistics_min_role';
export const SETTING_BUS_STOPS_REPORTS_MENUITEM = 'busstops_reports_menuitem';
export const SETTING_MZA_REPORTS_MENUITEM = 'mza_reports_menuitem';
export const SETTING_POSITION_HISTORY_ADMIN_MENU_ITEM_MIN_ROLE =
  'position_history_admin_menu_item_min_role';
export const SETTING_ZONES_MANAGEMENT_MIN_ROLE =
  'zones_management_min_role';
export const SETTING_STATUSES_HISTORY_ADMIN_MENU_ITEM_MIN_ROLE =
  'statuses_history_admin_menu_item_min_role';
export const SETTING_SHOW_ROUTE_MENU_ITEM = 'show_route_menu_item';
export const SETTING_ZONES_ENABLED = 'zones_enabled';
export const SETTING_VEHICLE_DEVICE_MAP_ENABLED = 'vehicle_device_map_enabled';
export const SETTING_DEPARTURE_PREVIEW_BUTTON_ENABLED = 'departure_preview_enabled';
export const SETTING_SHOW_MESSAGES_MENU_ITEM = 'show_messages_menu_item';
export const SETTING_VEHICLE_PROPERTIES_ENABLED = 'vehicle_properties_enabled';
export const SETTING_VEHICLE_CLIENT_VISIBILITY_ENABLED = 'vehicle_client_visibility_enabled';
export const SETTING_VEHICLE_PROPERTIES_EDITING_MIN_ROLE = 'vehicle_properties_editing_min_role';
export const SETTING_VEHICLE_PROPERTIES_VALUES_EDITING_MIN_ROLE =
  'vehicle_properties_values_editing_min_role';
export const SETTING_ROUTE_IDENTIFIER_FIELD = 'route_identifier_field';
export const SETTING_STOP_PILES_SHOW_PEOPLE_HEIGHT = 'stop_piles_show_people_height';
export const SETTING_MAX_DOORS = 'max_doors';
export const SETTING_REVERSE_VEHICLE_DOORS_IN_REPORT = 'reverse_vehicle_doors_in_report';
export const SETTING_VEHICLE_CONFIGURATION_ENABLED = 'vehicle_configuration_enabled';
export const SETTING_VEHICLE_CONFIGURATION_MIN_ROLE = 'vehicle_configuration_min_role';
export const SETTING_DSNG_SERVER_CONNECTION_ENABLED = 'dsng_server_connection_enabled';
export const SETTING_GO_BACK_TO_THE_DEPOT_MENU_ITEM = 'go_back_to_the_depot_menu_item';
export const SETTING_PUNCTUALITY_EARLY = 'punctuality_early';
export const SETTING_PUNCTUALITY_DELAYED = 'punctuality_delayed';
export const SETTING_PUNCTUALITY_LATE = 'punctuality_late';
export const SETTING_LIVE_DATA_REPORT_ENABLED = 'live_data_report_enabled';
export const SETTING_PANIC_BUTTON_CAMERA_VIDEO_PREVIEW_ENABLED =
  'panic_button_camera_video_preview_enabled';
export const SETTING_VEHICLE_TEAM_ASSIGNMENT_ENABLED = 'vehicle_team_assignment_enabled';
export const SETTING_REANALYZE_VEHICLE_DATA_MIN_ROLE = 'reanalyze_vehicle_data_min_role';
export const SETTING_ADMIN_SETTINGS_ENABLED = 'admin_settings_enabled';
export const SETTING_OPEN_ALL_VEHICLES_POPUPS_AT_START = 'open_all_vehicles_popups_at_start';
export const SETTING_VEHICLE_POPUP_CONTENT = 'vehicle_popup_content';
export const SETTING_VEHICLE_DISTANCE_WINDOW_ENABLED = 'vehicle_distance_window_enabled';
export const SETTING_INFO_MESSAGES_ENABLED = 'info_messages_enabled';
export const SETTING_CARRIERS_HANDLING_ENABLED = 'carriers_handling_enabled';
export const SETTING_SHOW_GROUPS_TO_ADMINS = 'show_groups_to_admins';
export const SETTING_DIRECTION_ROUTE_SOURCE = 'direction_route_source';
export const SETTING_SEGMENT_TRAVEL_TIME_WINDOW_ENABLED = 'segment_travel_time_window_enabled';
export const SETTING_MIN_DATE_FOR_SEGMENT_TRAVEL_TIME_CALCULATION =
  'min_date_for_segment_travel_time_calculation';
export const SETTING_MAX_DAYS_REPORT_REQUEST = 'max_days_report_request';
export const SETTING_ASK_ON_CLOSE_ASSIGNMENT_WINDOW = 'ask_on_close_assignment_window';
export const SETTING_USER_MANAGEMENT_ENABLED = 'user_management_enabled';
export const SETTING_REIMPORT_CONFIRMATION_ENABLED = 'reimport_confirmation_enabled';
export const SETTING_OFF_COURSE_ALERT_ENABLED = 'off_course_alert_enabled';
export const SETTING_OFF_COURSE_WINDOW_ENABLED = 'off_course_window_enabled';
export const SETTING_SHOW_ONLY_ON_COURSE_ENABLED = 'show_only_on_course_enabled';
export const SETTING_VEHICLE_CAMERA_PREVIEW_ENABLED = 'vehicle_camera_preview_enabled';
export const SETTING_BUS_STOP_MARKER = 'bus_stop_marker';
export const SETTING_BUS_STOP_POPUP_CONTENT = 'bus_stop_popup_content';
export const SETTING_BUS_STOPS_REPORTS_CHARTS_ENABLED = 'bus_stops_reports_charts_enabled';
export const SETTING_OPEN_FILTERS_ON_VEHICLES_PAGE = 'open_filters_on_vehicles_page';
export const SETTING_SHOW_POLYLINE_FOR_HISTORY_GPS_FRAMES = 'show_polyline_for_history_gps_frames';
export const SETTING_VEHICLE_OLD_POSITION_AFTER_MINUTES = 'vehicle_old_position_after_minutes';
export const SETTING_VEHICLE_EXPIRED_POSITION_AFTER_MINUTES = 'vehicle_expired_position_after_minutes';
export const SETTING_SHOW_LINE_PRIORITIES = 'show_line_priorities';
export const SETTING_VEHICLE_MANAGEMENT_MIN_ROLE = 'vehicle_management_min_role';
export const SETTING_VEHICLE_GROUPS_MIN_ROLE = 'vehicle_groups_min_role';
export const SETTING_MAX_DAYS_VEHICLE_DISTANCE_REPORT_REQUEST =
  'max_days_vehicle_distance_report_request';
export const SETTING_USER_ACTIVITY_LOG_ENABLED = 'user_activity_log_enabled';
export const SETTING_MAX_DAYS_SEGMENT_TRAVEL_TIME_REPORT_REQUEST =
  'max_days_segment_travel_time_report_request';
export const SETTING_ADS_ENABLED = 'ads_enabled';
export const SETTING_ADS_EXTERNAL_REPORTS_SYSTEM_URL = 'ads_external_reports_system_url';
export const SETTING_ARCHIVE_ENABLED = 'archive_enabled';
export const SETTING_PANIC_BUTTON_REPORT_ENABLED = 'panic_button_report_enabled';
export const SETTING_STOPPILE_STAT_DATA_REPORT_ENABLED = 'stoppile_stat_data_report_enabled';
export const SETTING_STOPPILE_STAT_DATA_REPORT_MIN_ROLE = 'stoppile-stat-data-report-min-role';
export const SETTING_SHOW_PERMANENT_VEHICLES_TOOLTIP = 'show_permanent_vehicles_tooltip';
export const SETTING_USER_ACTIVITY_TYPES = 'user_activity_types';
export const SETTING_VIEW_EXTERNAL_FILES_ENABLED = 'view_external_files_enabled';
export const SETTING_USER_FILE_SOURCE_TYPES = 'user_file_source_types';
export const SETTING_SHOW_FILES_TO_DOWNLOAD = 'show_files_to_download';
export const SETTING_SHOW_LIVE_VEHICLES_MAP = 'show_live_vehicles_map';
export const SETTING_VEHICLE_SYNC_STATUSES_ENABLED = 'vehicle_statuses_sync_enabled';
export const SETTING_VEHICLE_SYNC_STATUSES_MAX_DAYS = 'vehicle_statuses_sync_max_days';
export const SETTING_PASSENGER_REPORTS_CORRECTION_ENABLED = 'passenger_reports_correction_enabled';
export const SETTING_BUS_STOP_REPORT_NAME_OPTION = 'user_file_type_names';
export const SETTING_MZA_REPORTS_NAME = 'mza_reports';
export const SETTING_VEHICLE_POPUP_APPEAR_STRATEGY = 'vehicle_popup_appear_strategy';
export const SETTING_DATASYNC_ENABLED = 'datasync_enabled';
export const SETTING_COLORING_VEHICLE_BUS_STOP_MISSED = 'vehicle_bus_stop_missed_color';
export const AVAILABLE_EVENT_TYPE_COLORS = ['red', 'blue', 'orange'];
export const SETTING_VEHICLE_LAYOUT_ENABLED = 'vehicle_layout_enabled';
export const SETTING_GRAPH_REPORT_ENABLED = 'graph_report_enabled';
export const SETTING_SHOW_PHANTOMS_ENABLED = 'show_phantoms_enabled';
export const SETTING_MAKE_SNAPSHOTS_ENABLED = 'show_make_snapshots_enabled';
export const SETTINGS_VEHICLES_LAYOUT_CONFIGURATION_MIN_ROLE =
  'vehiclesLayoutConfigurationUserMinRole';
export const SETTINGS_USER_ACTIVITY_LOG_MIN_ROLE = 'userActivityLogMinRole';
export const SETTINGS_ERROR_MANAGMENT_MIN_ROLE =
  'errorManagementMinRole';
export const SETTING_ACCUMULATED_DATA_REPORT_ENABLED = 'accumulated-data-report.setting-enabled';
export const SETTING_ACCUMULATED_DATA_REPORT_MIN_ROLE = 'accumulated-data-report.setting-min-role';
export const SETTING_VEHICLE_TYPE_EDIT_ENABLED = 'vehicle_type_edit_enabled';
export const SETTING_SNVR_PLAYER_ENABLED = 'snvr_player_enabled';
export const SETTING_SNVR_EDIT_MODE_MIN_ROLE = 'snvr_edit_mode_min_role';
export const SETTING_IMPORT_STATISTICS_ENABLED = 'import_statistics_enabled';
export const SETTING_PASSENGER_RESET_STOPS_ENABLED = 'passenger_reset_stops_enabled';
export const SETTING_ERROR_LOG_REPORT_ENABLE = 'diagnosticModul';
export const SETTING_ERROR_LOG_REPORT_DEVICES = 'diagnosticModulDevices';
export const SETTING_TML_ENABLED = 'tml_enabled';
export const SETTING_ADS_ALARM_NOTIFICATIONS_ENABLED = 'settingAdsAlarmNotificationsEnabled';
export const SETTINGS_ADS_PREVIEW_ENABLED = 'adsPreviewEnabled';
export const ENABLED_SNVR_MODULES = 'enabledSnvrModules';
export const SETTING_AVAILABLE_DEVICE_SETTINGS = 'settingsAvailableDeviceSettings';
export const SETTINGS_ADS_ADVERTISEMENT_OPTIONS = 'adsAdvertisementOptions';
export const SETTINGS_ADS_ALARM_OPTIONS = 'adsAlarmOptions';
export const SETTINGS_DIALOGS_IN_VEHICLE_MANAGEMENT = 'settingDialogsInVehicleManagement';
export const SETTINGS_DIAGNOSTICS_ENABLED = 'settingsDiagnosticsEnabled';
export const SETTINGS_DIAGNOSTICS_GRAFANA_ENABLED = 'settingsDiagnosticsGrafanaEnabled';
export const SETTINGS_OPEN_CAMERA_CONFIG_DIALOG_ENABLED = 'settingOpenCameraConfigDialogEnabled';
export const SETTINGS_SNVR_AUTOMATICALY_ADD_INFRASTUCTURE_ENABLED =
  'settingsSnvrAutomaticalyAddInfrastuctureEnabled';
export const CAMERA_SETTINGS_REDIRECTION_ENABLED = 'cameraSettingsRedirectionEnabled';
export const SETTING_DEPOTS_ENABLED = 'settingDepotsEnabled';
export const ALLOW_DEPOTS_MANAGEMENT = 'allowDepotsManagement';
export const SETTINGS_REMEDIAL_STEPS_ENABLED = 'settingsRemedialStepsEnabled';
export const SETTING_ENABLE_DEVICE_SOFTWARE_UPDATE = 'settingEnableDeviceSoftwareUpdate';
export const SETTING_MIN_USER_ROLE_TO_DO_DEVICE_SOFTWARE_UPDATE =
  'settingMinUserRoleToDoDeviceSoftwareUpdate';
export const SETTING_SOFTWARE_CAMPAIGN_ENABLED = 'settingSoftwareCampaignEnabled';
export const SETTING_SOFTWARE_CAMPAIGN_DISABLE_DOING_UPDATES_WHILE_UPDATE_PENDING = 'settingSoftwareCampaignDisableUpdateWhilePending';
export const SETTING_SOFTWARE_CAMPAIGN_AVAILABLE_DEVICES =
  'settingSoftwareCampaignAvailableDevices';
export const SETTINGS_PANEL_AVAILABLE_DEVICES = 'settingsPanelAvailableDevices';
export const SETTINGS_GLOBAL_PANEL_AVAILABLE_DEVICES = 'settingsGlobalPanelAvailableDevices';
export const SETTINGS_IMPORT_TIMETABLES_DATA = 'importTimetablesData';
export const SETTINGS_ALLOWED_IMPORTS_LIST = 'allowedImportsList';
export const AVAILABLE_IMPORTS = [SETTINGS_IMPORT_TIMETABLES_DATA];
export const SETTING_SCHEDULE_ENABLED = 'settingsScheduleEnabled';
export const SETTING_SHOULD_SHOW_PLAYLIST_FILE_REPORT = 'shouldShowPlaylistFileReport';
export const SETTING_HANDLE_FILE_STATUS_UPDATE_ENABLED = 'settingHandleFileStatusUpdateEnabled';
export const SETTING_VEHICLE_DISPLAY_SYNC_ENABLED = 'settingVehicleDisplaySyncEnabled';
export const SETTING_ADS_ACCEPTABLE_EXPENSIONS_ENABLED = 'settingAdsAcceptableExtensions';
export const SETTING_REVERCE_TIMETABLE_DEVIATION = 'settingReverseTimetableDeviation';
export const SETTING_DELETE_DRIVER_SNAPSHOTS_ENABLED = 'settingDeleteDriverSnapshotsEnabled';
export const SETTING_NOTIFY_ON_NEW_SNAPSHOT_FILE = 'settingNotifyOnNewSnapshotFile';
export const SETTING_CHAT_ENABLED = 'settingChatEnabled';
export const SETTING_EVENT_OCCURRENCE_TIME_ENABLED = 'eventOccurrenceTimeEnabled';
export const SETTING_SIL_DATA_UPLOAD_REPORT_ENABLED = 'silDataUploadReportEnabled';
export const SETTING_DOWNLOAD_ZIPPED_PLAYLIST_REPORT_ENABLED =
  'downloadZippedPlaylistReportEnabled';
export const TRANSLATIONS_MANAGEMENT_MIN_ROLE = 'translationManagementMinRole';
export const VISIBLE_USER_ROLES = 'visibleUserRoles';
export const SETTING_ROAD_SCHEDULE_IN_MENU_ENABLED = 'roadScheduleEnabledInMenu';
export const SETTING_PASSENGER_REPORT_ENABLED = 'settingPassengerReportEnabled';
export const SETTING_SHOW_USER_LOGGED_MENU_ITEM = 'settingShowUserLoggedMenuItem';
export const SETTING_SHOW_MAP_VEHICLE_ERROR_STRATEGY = 'settingShowMapVehicleErrorStrategy';
export const SETTING_RESET_STOPS_EDITING_MIN_ROLE = 'settingResetStopsEditingMinRole';
export const SETTING_ALCOHOL_TEST_REQUEST = 'alcoholTestRequestEnabled';
export const SETTING_VOICE_CHAT_ENABLED = 'voiceChatEnabled';
export const SETTING_VEHICLE_GROUPS_EDITING_ENABLED = 'vehicleGroupsEditingEnabled';
export const SETTING_DEVICES_MIN_ROLE = 'devicesMinRole';
export const SETTINGS_VOICE_ANNOUCEMENTS_ENABLED = 'voiceAnnoucementsEnabled';
export const SETTING_SNVR_MAX_REQUEST_TIME_RANGE = 'snvrMaxRequestTimeRange';
export const SETTING_SHOW_USER_LOGGED_NO_INTERNET_TIMEOUT = 'showUserLoggerNoInternetTimeout';
export const SAKP_ENABLED = 'sakp.settings.enabled';
export const SAKP_COLORIZE_ROWS_ENABLED = 'sakp.settings.colored-rows-enabled';
export const SAKP_DEPARTURE_REPORT_FIELDS = 'sakp.settings.departure-fields';
export const SAKP_FLEETMANAGEMENT_EDITING_AFTER_DEADLINE_ENABLED = 'settingSakpFleetmanagementEditAfterDeadlineEnabled';
export const SAKP_FLEETMANAGEMENT_NUMBER_OF_EDITABLE_DAYS_AFTER_DEADLINE = 'sakp.settings.fleetmanagement-number-of-editable-days-after-deadline';
export const FILTER_HISTORY_MAX_SIZE = 'filter-history-max-size';
export const ENABLE_TABLE_PRINT = 'local-print.enabled';

export const GLOBAL_SETTINGS_GROUP = 'global';


export const SETTINGS_GROUPS: SettingGroup[] = [
  {
    name: 'vehicles',
    settings: [
      {
        name: SETTING_SHOW_ROUTE_MENU_ITEM,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_ZONES_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_DEVICE_MAP_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_DEPARTURE_PREVIEW_BUTTON_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SHOW_MESSAGES_MENU_ITEM,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_PROPERTIES_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_CLIENT_VISIBILITY_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_PROPERTIES_EDITING_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_VEHICLE_PROPERTIES_VALUES_EDITING_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_ROUTE_IDENTIFIER_FIELD,
        default: RouteIdentifierType.route_id,
        type: SettingType.SINGLE_OPTION,
        options: [RouteIdentifierType.route_id, RouteIdentifierType.route_code]
      },
      {
        name: SETTING_VEHICLE_CONFIGURATION_ENABLED,
        default: true,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_CONFIGURATION_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_GO_BACK_TO_THE_DEPOT_MENU_ITEM,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        // Próg musi mieć wartość: bez niego getDelayType nie zwraca nic i cała flota idzie jako
        // "opóźnienie nieznane", czyli bez kolorów. Zakres od 1, bo próg liczy się z przeciwnym znakiem
        // ("minutę lub więcej przed rozkładem") i wartość ujemna odwracałaby sens ustawienia.
        name: SETTING_PUNCTUALITY_EARLY,
        default: 1,
        type: SettingType.INTEGER,
        range: [1, 100]
      },
      {
        // Pierwszy stopień opóźnienia; trzy minuty to tyle, ile pojazd nadrabia jeszcze sam między
        // przystankami.
        name: SETTING_PUNCTUALITY_DELAYED,
        default: 3,
        type: SettingType.INTEGER,
        range: [1, 100]
      },
      {
        // Drugi stopień: kwadrans to już wypadnięcie z rozkładu, nie opóźnienie w ruchu.
        name: SETTING_PUNCTUALITY_LATE,
        default: 15,
        type: SettingType.INTEGER,
        range: [1, 100]
      },
      {
        name: SETTING_PANIC_BUTTON_CAMERA_VIDEO_PREVIEW_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_TEAM_ASSIGNMENT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_ASK_ON_CLOSE_ASSIGNMENT_WINDOW,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_OFF_COURSE_ALERT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SHOW_ONLY_ON_COURSE_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_CAMERA_PREVIEW_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_OPEN_FILTERS_ON_VEHICLES_PAGE,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        // Próg musi mieć wartość, inaczej przygaszanie nieaktywnych pojazdów się nie włącza. Minuta to
        // próg widoku bieżącego - pojazd w ruchu melduje się znacznie częściej.
        name: SETTING_VEHICLE_OLD_POSITION_AFTER_MINUTES,
        default: 1,
        type: SettingType.INTEGER,
        range: [1, 43200]
      },
      {
        // Drugi stopień starzenia pozycji: po tym progu pozycja jest "nieważna", a nie tylko
        // "nieaktualna" - pojazd zdążył zjechać albo wypaść z zasięgu.
        name: SETTING_VEHICLE_EXPIRED_POSITION_AFTER_MINUTES,
        default: 15,
        type: SettingType.INTEGER,
        range: [1, 43200]
      },
      {
        name: SETTING_SHOW_LINE_PRIORITIES,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_VEHICLE_MANAGEMENT_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_VEHICLE_GROUPS_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_SHOW_LIVE_VEHICLES_MAP,
        default: true,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_LAYOUT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_VEHICLES_LAYOUT_CONFIGURATION_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_VEHICLE_TYPE_EDIT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_AVAILABLE_DEVICE_SETTINGS,
        default: null,
        type: SettingType.MULTIPLE_OPTIONS,
        options: Object.values(DeviceSettingsType)
      },
      {
        name: SETTINGS_PANEL_AVAILABLE_DEVICES,
        default: null,
        type: SettingType.MULTIPLE_OPTIONS,
        options: getPhysicalDeviceTypes()
      },
      {
        name: SETTINGS_GLOBAL_PANEL_AVAILABLE_DEVICES,
        default: null,
        type: SettingType.MULTIPLE_OPTIONS,
        options: getPhysicalDeviceTypes()
      },
      {
        name: SETTING_MAKE_SNAPSHOTS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_DISPLAY_SYNC_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_DELETE_DRIVER_SNAPSHOTS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_NOTIFY_ON_NEW_SNAPSHOT_FILE,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_CHAT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_REANALYZE_VEHICLE_DATA_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_ALCOHOL_TEST_REQUEST,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_ERROR_MANAGMENT_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      }
    ]
  },
  {
    name: 'reports',
    settings: [
      {
        name: SETTING_ACCUMULATED_DATA_REPORT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_ACCUMULATED_DATA_REPORT_MIN_ROLE,
        default: UserRole.MEMBER,
        type: SettingType.ROLE
      },
      {
        name: SETTING_DEVICES_BUTTON,
        default: true,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_BUS_STOPS_STATISTICS_MENUITEM,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_BUS_STOPS_STATISTICS_MIN_ROLE,
        default: UserRole.MEMBER,
        type: SettingType.ROLE
      },
      {
        name: SETTING_BUS_STOPS_REPORTS_MENUITEM,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_MZA_REPORTS_MENUITEM,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_POSITION_HISTORY_ADMIN_MENU_ITEM_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_STATUSES_HISTORY_ADMIN_MENU_ITEM_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_STOP_PILES_SHOW_PEOPLE_HEIGHT,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_MAX_DOORS,
        default: 0,
        type: SettingType.INTEGER,
        range: [0, 6]
      },
      {
        name: SETTING_REVERSE_VEHICLE_DOORS_IN_REPORT,
        default: true,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_DISTANCE_WINDOW_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SEGMENT_TRAVEL_TIME_WINDOW_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_MAX_DAYS_REPORT_REQUEST,
        default: 31,
        type: SettingType.INTEGER,
        range: [1, 366]
      },
      {
        name: SETTING_MAX_DAYS_VEHICLE_DISTANCE_REPORT_REQUEST,
        default: 31,
        type: SettingType.INTEGER,
        range: [1, 366]
      },
      {
        name: SETTING_MAX_DAYS_SEGMENT_TRAVEL_TIME_REPORT_REQUEST,
        default: 31,
        type: SettingType.INTEGER,
        range: [1, 366]
      },
      {
        name: SETTING_OFF_COURSE_WINDOW_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_BUS_STOPS_REPORTS_CHARTS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_ARCHIVE_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_PANIC_BUTTON_REPORT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VIEW_EXTERNAL_FILES_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_SYNC_STATUSES_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_SYNC_STATUSES_MAX_DAYS,
        default: 3,
        type: SettingType.INTEGER,
        range: [1, 366]
      },
      {
        name: SETTING_PASSENGER_REPORTS_CORRECTION_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_BUS_STOP_REPORT_NAME_OPTION,
        default: BusStopReportNameOptions.BUS_STOP_REPORT,
        type: SettingType.SINGLE_OPTION,
        options: Object.keys(BusStopReportNameOptions)
      },
      {
        name: SETTING_COLORING_VEHICLE_BUS_STOP_MISSED,
        default: '',
        type: SettingType.SINGLE_OPTION,
        options: AVAILABLE_EVENT_TYPE_COLORS
      },
      {
        name: SETTING_GRAPH_REPORT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_IMPORT_STATISTICS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_ERROR_LOG_REPORT_ENABLE,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SCHEDULE_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SHOULD_SHOW_PLAYLIST_FILE_REPORT,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_REVERCE_TIMETABLE_DEVIATION,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_EVENT_OCCURRENCE_TIME_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SIL_DATA_UPLOAD_REPORT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_DOWNLOAD_ZIPPED_PLAYLIST_REPORT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_PASSENGER_REPORT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_LIVE_DATA_REPORT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_GROUPS_EDITING_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_DEVICES_MIN_ROLE,
        default: false,
        type: SettingType.ROLE
      },
      {
        name: SETTING_STOPPILE_STAT_DATA_REPORT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_STOPPILE_STAT_DATA_REPORT_MIN_ROLE,
        default: false,
        type: SettingType.ROLE
      }
    ]
  },
  {
    name: 'map',
    settings: [
      {
        name: SETTING_OPEN_VEHICLE_DEVICES,
        default: true,
        type: SettingType.BOOLEAN,
        deprecated: true
      },
      {
        name: SETTING_VEHICLE_MARKER,
        default: VEHICLE_MARKER_OPTIONS[0],
        type: SettingType.IMAGE,
        options: VEHICLE_MARKER_OPTIONS
      },
      {
        name: SETTING_VEHICLE_STATUS_MARKER,
        default: VEHICLE_STATUS_MARKER_OPTIONS[0],
        type: SettingType.IMAGE,
        options: VEHICLE_STATUS_MARKER_OPTIONS
      },
      {
        name: SETTING_MAP_INITIAL_LATITUDE,
        default: 52.4415218,
        type: SettingType.FLOAT,
        range: [-90.0, 90.0]
      },
      {
        name: SETTING_MAP_INITIAL_LONGITUDE,
        default: 19.4686095,
        type: SettingType.FLOAT,
        range: [-180.0, 180.0]
      },
      {
        name: SETTING_MAP_INITIAL_ZOOM,
        default: 8,
        type: SettingType.INTEGER,
        range: [1, 19]
      },
      {
        name: SETTING_BUS_STOPS_MENUITEM,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_OPEN_ALL_VEHICLES_POPUPS_AT_START,
        default: false,
        type: SettingType.BOOLEAN,
        deprecated: true
      },
      {
        name: SETTING_SHOW_PERMANENT_VEHICLES_TOOLTIP,
        default: false,
        type: SettingType.BOOLEAN,
        deprecated: true
      },
      {
        name: SETTING_VEHICLE_POPUP_CONTENT,
        default: 'sideNumber,line,receiveTime',
        type: SettingType.MULTIPLE_OPTIONS,
        options: VEHICLE_POPUP_FIELDS
      },
      {
        name: SETTING_BUS_STOP_MARKER,
        default: BUS_STOP_MARKER_OPTIONS[0],
        type: SettingType.IMAGE,
        options: BUS_STOP_MARKER_OPTIONS
      },
      {
        name: SETTING_BUS_STOP_POPUP_CONTENT,
        default: 'name,code',
        type: SettingType.MULTIPLE_OPTIONS,
        options: BUS_STOP_POPUP_FIELDS
      },
      {
        name: SETTING_DIRECTION_ROUTE_SOURCE,
        default: DirectionRouteSourceType.disabled,
        type: SettingType.SINGLE_OPTION,
        options: [
          DirectionRouteSourceType.disabled,
          DirectionRouteSourceType.polyline,
          DirectionRouteSourceType.route
        ]
      },
      {
        name: SETTING_SHOW_POLYLINE_FOR_HISTORY_GPS_FRAMES,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VEHICLE_POPUP_APPEAR_STRATEGY,
        type: SettingType.SINGLE_OPTION,
        deprecated: true,
        default: 'hover',
        // Wartości wpisane wprost, bo typu MarkerPopupApperStrategy już nie ma.
        options: ['hover', 'click', 'permanent']
      },
      {
        name: SETTING_SHOW_USER_LOGGED_MENU_ITEM,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SHOW_PHANTOMS_ENABLED,
        default: true,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SHOW_MAP_VEHICLE_ERROR_STRATEGY,
        default: GpsFrameShowErrorStrategy.BY_FILED_ERROR,
        type: SettingType.SINGLE_OPTION,
        options: Object.values(GpsFrameShowErrorStrategy)
      },
      {
        name: SETTING_SHOW_USER_LOGGED_NO_INTERNET_TIMEOUT,
        default: 5,
        type: SettingType.INTEGER
      }
    ]
  },
  {
    name: 'DS',
    settings: [
      {
        name: SETTING_DATASYNC_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_ROAD_SCHEDULE_IN_MENU_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      }
    ]
  },
  {
    name: 'ADS',
    settings: [
      {
        name: SETTING_ADS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_ADS_EXTERNAL_REPORTS_SYSTEM_URL,
        default: null,
        type: SettingType.TEXT
      },
      {
        name: SETTING_ADS_ALARM_NOTIFICATIONS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_ADS_PREVIEW_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_ADS_ADVERTISEMENT_OPTIONS,
        default: Object.values(ParamsFormOptions),
        type: SettingType.MULTIPLE_OPTIONS,
        options: Object.values(ParamsFormOptions)
      },
      {
        name: SETTINGS_ADS_ALARM_OPTIONS,
        default: Object.values(ParamsFormOptions),
        type: SettingType.MULTIPLE_OPTIONS,
        options: Object.values(ParamsFormOptions)
      },
      {
        name: SETTING_ADS_ACCEPTABLE_EXPENSIONS_ENABLED,
        default: 'img, png, jpg, jpeg, mp4, avi',
        type: SettingType.TEXT
      }
    ]
  },
  {
    name: 'SNVR',
    settings: [
      {
        name: ENABLED_SNVR_MODULES,
        default: SnvrParts.TASKS,
        type: SettingType.MULTIPLE_OPTIONS,
        options: getAllSnvrParts()
      },
      {
        name: SETTING_SNVR_PLAYER_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SNVR_EDIT_MODE_MIN_ROLE,
        default: false,
        type: SettingType.ROLE
      },
      {
        name: SETTINGS_SNVR_AUTOMATICALY_ADD_INFRASTUCTURE_ENABLED,
        default: true,
        type: SettingType.BOOLEAN
      },
      {
        name: CAMERA_SETTINGS_REDIRECTION_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SNVR_MAX_REQUEST_TIME_RANGE,
        default: false,
        type: SettingType.INTEGER
      }
    ]
  },
  {
    name: 'softwareCampaign',
    settings: [
      {
        name: SETTING_SOFTWARE_CAMPAIGN_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_SOFTWARE_CAMPAIGN_AVAILABLE_DEVICES,
        default: [DeviceType.SIL],
        type: SettingType.MULTIPLE_OPTIONS,
        options: getPhysicalDeviceTypes()
      },
      {
        name: SETTING_MIN_USER_ROLE_TO_DO_DEVICE_SOFTWARE_UPDATE,
        default: ServiceSettingsRoles.SERVICE,
        type: SettingType.ROLE
      },
      {
        name: SETTING_SOFTWARE_CAMPAIGN_DISABLE_DOING_UPDATES_WHILE_UPDATE_PENDING,
        default: true,
        type: SettingType.BOOLEAN
      }
    ]
  },
  {
    name: 'management',
    settings: [
      {
        name: SETTING_PASSENGER_RESET_STOPS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_RESET_STOPS_EDITING_MIN_ROLE,
        default: UserRole.ADMIN,
        type: SettingType.ROLE
      },
      {
        name: SETTING_USER_MANAGEMENT_ENABLED,
        default: true,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_DIALOGS_IN_VEHICLE_MANAGEMENT,
        default: [],
        type: SettingType.MULTIPLE_OPTIONS,
        options: [SETTINGS_OPEN_CAMERA_CONFIG_DIALOG_ENABLED, SETTING_ENABLE_DEVICE_SOFTWARE_UPDATE]
      },
      {
        name: VISIBLE_USER_ROLES,
        type: SettingType.MULTIPLE_OPTIONS,
        default: Object.values(UserRole),
        options: Object.values(UserRole)
      },
      {
        name: SETTING_ADMIN_SETTINGS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: ALLOW_DEPOTS_MANAGEMENT,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: SETTING_DEPOTS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_USER_ACTIVITY_LOG_MIN_ROLE,
        default: SETTING_VALUE_DISABLED,
        type: SettingType.ROLE
      },
      {
        name: TRANSLATIONS_MANAGEMENT_MIN_ROLE,
        default: null,
        type: SettingType.ROLE
      },
      {
        name: SETTING_SHOW_GROUPS_TO_ADMINS,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_DIAGNOSTICS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_DIAGNOSTICS_GRAFANA_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_VOICE_ANNOUCEMENTS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      }
    ]
  },
  {
    name: GLOBAL_SETTINGS_GROUP,
    settings: [
      {
        name: SETTING_DSNG_SERVER_CONNECTION_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_INFO_MESSAGES_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_CARRIERS_HANDLING_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_REIMPORT_CONFIRMATION_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_USER_ACTIVITY_LOG_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_USER_ACTIVITY_TYPES,
        default: Object.keys(UserActivityEventType),
        type: SettingType.MULTIPLE_OPTIONS,
        options: Object.keys(UserActivityEventType)
      },
      {
        name: SETTING_USER_FILE_SOURCE_TYPES,
        default: Object.keys(FileTable),
        type: SettingType.MULTIPLE_OPTIONS,
        options: Object.keys(FileTable)
      },
      {
        name: SETTING_SHOW_FILES_TO_DOWNLOAD,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_ERROR_LOG_REPORT_DEVICES,
        default: getDeviceTypesForErrorLogReport(),
        type: SettingType.MULTIPLE_OPTIONS,
        options: getDeviceTypesForErrorLogReport()
      },
      {
        name: SETTING_TML_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_REMEDIAL_STEPS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTINGS_ALLOWED_IMPORTS_LIST,
        default: [],
        type: SettingType.MULTIPLE_OPTIONS,
        options: AVAILABLE_IMPORTS
      },
      {
        name: SETTING_HANDLE_FILE_STATUS_UPDATE_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_VOICE_CHAT_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SETTING_ZONES_MANAGEMENT_MIN_ROLE,
        default: false,
        type: SettingType.ROLE
      },
      {
        name: FILTER_HISTORY_MAX_SIZE,
        default: 10,
        type: SettingType.INTEGER
      },
      {
        name: ENABLE_TABLE_PRINT,
        default: true,
        type: SettingType.BOOLEAN
      }
    ]
  },
  {
    name: 'SAKP',
    settings: [
      {
        name: SAKP_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SAKP_COLORIZE_ROWS_ENABLED,
        default: false,
        type: SettingType.BOOLEAN
      },
      {
        name: SAKP_DEPARTURE_REPORT_FIELDS,
        default: [
          DepartureFields.DAY,
          DepartureFields.ID,
          DepartureFields.CREATED_AT,
          DepartureFields.UPDATED_AT,

          DepartureFields.COURSE_DAY_TYPE,
          DepartureFields.COURSE_BRIGADE,
          DepartureFields.COURSE_LINE,
          DepartureFields.COURSE_DIRECTION,
          DepartureFields.COURSE_NAME,
          DepartureFields.COURSE_BEGIN_TIME,
          DepartureFields.COURSE_END_TIME,

          DepartureFields.STOP_INDEX,
          DepartureFields.STOP_TIME,
          DepartureFields.STOP_CODE,
          DepartureFields.STOP_NAME,

          DepartureFields.RT_VEHICLE_SIDE_NUMBER,
          DepartureFields.RT_VEHICLE_TIMESTAMP,

          DepartureFields.CLAIMS
        ],
        type: SettingType.MULTIPLE_OPTIONS,
        options: Object.values(DepartureFields)
      },
      {
        name: SAKP_FLEETMANAGEMENT_EDITING_AFTER_DEADLINE_ENABLED,
        type: SettingType.BOOLEAN,
        default: false
      },
      {
        name: SAKP_FLEETMANAGEMENT_NUMBER_OF_EDITABLE_DAYS_AFTER_DEADLINE,
        type: SettingType.INTEGER,
        default: 14
      }
    ]
  }
];

export const SETTINGS_MAP = keyBy(
  flatten(SETTINGS_GROUPS.map(group => group.settings)),
  setting => setting.name
);

export const VEHICLE_CONFIGURATION_SIDE_NUMBER = 'sil-side_number';
export const VEHICLE_CONFIGURATION_VOLUME = 'audio-ratio';

export const MARKERS_SETTINGS: MarkersSettings = {
  blackTriangle: {
    size: [0, 0],
    anchor: [8, 8],
    name: 'blackTriangle',
    type: Type.STANDARD
  },
  grayMarker: {
    size: [20, 20],
    anchor: [10, 10],
    name: 'grayMarker',
    type: Type.STANDARD
  },
  blueMarker: {
    size: [20, 20],
    anchor: [10, 10],
    name: 'blueMarker',
    type: Type.STANDARD
  },
  stopImageBlack: {
    size: [26, 32],
    anchor: [13, 16],
    name: 'stopImageBlack',
    type: Type.IMAGE
  },
  stopImageBlue: {
    size: [26, 32],
    anchor: [13, 16],
    name: 'stopImageBlue',
    type: Type.IMAGE
  },
  stopImagePurple: {
    size: [26, 32],
    anchor: [13, 16],
    name: 'stopImagePurple',
    type: Type.IMAGE
  }
};

interface MarkersSettings {
  [key: string]: MarkerType;
}
